export default "__VITE_ASSET__gLhonzD_NsmiMs4JsssZzg__"